<template>
  <v-dialog
    v-model="dialog"
    width="500"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title class="amber darken-1 white--text"
        >Thêm mới ảnh trong Slider sản phẩm
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-form ref="form" v-model="valid" flat class="pa-4">
        <v-text-field
          label="Tên"
          v-model="title"
          outlined
          required
          dense
        ></v-text-field>
        <v-textarea
          ref="description"
          v-model="description"
          label="Mô Tả"
          placeholder="Nhập mô tả"
          dense
          outlined
        ></v-textarea>
        <v-text-field
          ref="link"
          v-model="link"
          label="Đường dẫn"
          placeholder="Nhập đường dẫn tới bài viết"
          dense
          outlined
        ></v-text-field>
        <v-file-input
          v-model="file"
          class="mt-1"
          color="deep-purple accent-4"
          label="File input"
          placeholder="Tải ảnh lên"
          :show-size="1000"
          counter
          outlined
        >
          <template v-slot:selection="{ index, text }">
            <v-chip
              v-if="index < 2"
              color="deep-purple accent-4"
              dark
              label
              small
              >{{ text }}</v-chip
            >
            <span
              v-else-if="index === 2"
              class="overline grey--text text--darken-3 mx-2"
              >+{{ files.length - 2 }} File(s)</span
            >
          </template>
        </v-file-input>
        <v-text-field
          ref="embed"
          v-model="embed"
          label="Link nhúng (Embed code)"
          placeholder="Điền link nhúng"
          required
          dense
          outlined
        ></v-text-field>
      </v-form>
      <v-card-actions class="pr-4 pb-8">
        <v-spacer />
        <v-btn class="px-4" color="primary" @click="save" :loading="loading"
          >Lưu</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ShowcaseInfoForm from '@/components/basic/form/ShowcaseForm.vue'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    ShowcaseInfoForm,
  },
  props: {
    state: Boolean,
    major: Object,
    course: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      valid: true,
      title: '',
      description: '',
      link: '',
      file: null,
      embed: '',
    }
  },
  computed: {
    ...mapState('app', ['roles', 'department']),
    ...mapState('auth', ['user']),
    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm Mới Showcase'
      }
    },
  },
  methods: {
    ...mapActions('showcases', ['createShowcase', 'upload', 'fetchShowcases']),
    async save() {
      this.loading = true
      let form = this.$refs.form
      let data = this.getData()
      if (form.validate()) {
        let showcase = await this.createShowcase({
          ...data,
          data: { link: data.embed },
        })
        await this.upload({
          showcaseId: showcase.id,
          file: data.file,
        })
        await this.fetchShowcases({
          department: this.department.id,
          position_contains: 'home-page',
        })
        this.dialog = false
        this.$refs.form.reset()
      }
      this.loading = false
    },
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    },
    async reset() {
      // this.$refs.form.reset()
      if (this.showcase) {
        this.$loading.active = true
        this.description = this.showcase.description
        this.title = this.showcase.title
        this.course = this.showcase.course
        this.link = this.showcase.link
        this.embed =
          this.showcase.data && this.showcase.data.link
            ? this.showcase.data.link
            : ''
        this.$loading.active = false
        this.file = null
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    validate() {
      this.$refs.form.validate()
      return this.valid
    },
    getData() {
      let data = {
        description: this.description,
        title: this.title,
        link: this.link,
        position: 'home-page',
        department: this.department.id,
        embed: this.embed,
      }
      if (this.file) data.file = this.file
      return data
    },
  },
  watch: {
    state(state) {
      this.dialog = true
    },
    showcase(showcase) {
      this.reset()
    },
  },
}
</script>
